// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__23Hgt","insightsList":"newBusinessInsightsMenu_insightsList__2JuyP","active":"newBusinessInsightsMenu_active__2TtEE"};